'use strict';

define(function (require) {

    var browserInfo = window.deviceBootstrap();
    var main = document.querySelector('main');
    var cookies = require('bam.cookies/cookies');

    function browserAlert(type) {
        var alert = document.createElement('div');
        var alertInnerHTML = null;
        alert.style.maxWidth = '1284px';
        alert.style.width = '100%';
        alert.style.margin = 'auto';
        alert.style.position = 'relative';
        if (type === 'basic') {
            alertInnerHTML = [
                '<div class="p-alert p-alert--error">',
                '<div class="p-alert__text">',
                '<p><strong>Please upgrade your browser</strong></p>',
                '<p>Our site is not supported in your current browser. ',
                'Please upgrade it to the current version in order to continue.</p>',
                '</div>',
                '</div>'
            ].join('');
            alert.innerHTML = alertInnerHTML;
            return alert;
        } else if (type === 'close') {
            alertInnerHTML = [
                '<div class="p-alert p-alert--error">',
                '<div class="p-alert__text">',
                '<p><strong>Please upgrade your browser</strong></p>',
                '<p>Our site is not optimized for your current browser. ',
                'Please upgrade to the current version to receive the best site experience.</p>',
                '</div>',
                '</div>'
            ].join('');
            alert.innerHTML = alertInnerHTML;
            var closeIcon = document.createElement('div');
            closeIcon.className = 'close-browser-alert';
            closeIcon.innerHTML = [
                '<svg class="p-icon p-icon--close" style="width: 1rem; height: 1rem;">',
                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>',
                '</svg>'
            ].join('');
            closeIcon.style.position = 'absolute';
            closeIcon.style.top = '0px';
            closeIcon.style.right = '5px';
            closeIcon.style.cursor = 'pointer';
            closeIcon.addEventListener('click', function () {
                setCookie(); // eslint-disable-line no-use-before-define
                alert.parentNode.removeChild(alert);
            }, false);
            alert.appendChild(closeIcon);
            return alert;
        }
        return '';
    }

    function setCookie() {
        var date = new Date();
        date.setFullYear(date.getFullYear() + 1);
        cookies.set({
            name: 'browserAlert',
            value: 'true',
            domain: '.mlb.com',
            path: '/',
            expires: date,
            secure: true
        });
    }

    function unsupportedBrowser() {
        var browserVersion = parseInt(browserInfo.browserVersion.split('.')[0], 10);
        return (browserInfo.browser === 'msie' && browserVersion === 10) ||
        (browserInfo.browser === 'safari' && browserVersion <= 8);
    }

    function nagBrowser() {
        var browserVersion = parseInt(browserInfo.browserVersion.split('.')[0], 10);
        return (browserInfo.browser === 'safari' && browserVersion === 9);
    }

    /**
     * If its an unsupported browser, i.e. IE 10, Safari 8 and below then display alert.
     */
    if (unsupportedBrowser()) {
        main.insertBefore(browserAlert('basic'), main.firstChild);
    }

    /**
     * If its a nag browser, i.e. Safari 9 then display nag alert.
     */
    if (nagBrowser()) {
        if (cookies.get('browserAlert') === null) {
            main.insertBefore(browserAlert('close'), main.firstChild);
        }
    }
});
